














  import {Component, Prop, Vue, Watch} from "vue-property-decorator";
  import {equals} from "../../utils";


  @Component({
    components: {},
  })
  export default class DatePicker extends Vue {
    // Value passed by v-model
    @Prop() public readonly value: any
    public mutable = this.value

    //public date = new Date().toISOString().substr(0, 10)
    public modal = false

    // If the v-model is updated in the parent
    @Watch('value')
    public valueChanged(newValue: any, oldValue: any) {
      if (!equals(newValue, oldValue)) {
        // if(newValue.latitude && newValue.longitude) {}
        this.mutable = newValue

      }
    }
    @Watch('mutable')
    public changeDate() {
      this.$emit('input', this.mutable.toLocaleString())
    }


}
